
document.addEventListener('DOMContentLoaded', function(){
  // Floating review modal
  const floatingReview = document.querySelector('.review-float');
  const modal = document.getElementById('modalReview');
  if(floatingReview && modal){
    floatingReview.addEventListener('click', function(e){
      e.preventDefault();
      modal.style.display = 'flex';
    });
  }

  // Modal controls if present
  const revCancel = document.getElementById('rCancel');
  const revSend = document.getElementById('rSend');
  const reviewsGrid = document.getElementById('reviews-grid');
  function escapeHtml(str){ return str.replace(/[&<>"']/g, function(m){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":"&#39;"}[m]; }); }

  if(revCancel){
    revCancel.addEventListener('click', function(){ document.getElementById('modalReview').style.display='none'; });
  }
  if(revSend){
    revSend.addEventListener('click', function(){
      const name = (document.getElementById('rName').value || 'Anoniem').trim();
      const text = (document.getElementById('rText').value || '').trim();
      if(!text){ alert('Vul je review in aub.'); return; }
      const card = document.createElement('div');
      card.className = 'review-card';
      card.innerHTML = '<p>“'+ escapeHtml(text) +'”</p><strong>— '+ escapeHtml(name) +'</strong>';
      if(reviewsGrid) reviewsGrid.prepend(card);
      try{
        const store = JSON.parse(localStorage.getItem('elegance_reviews')||'[]');
        store.unshift({name,text,date:new Date().toISOString()});
        localStorage.setItem('elegance_reviews', JSON.stringify(store));
      }catch(e){}
      document.getElementById('rName').value=''; document.getElementById('rText').value='';
      document.getElementById('modalReview').style.display='none';
      setTimeout(function(){ var rv = document.getElementById('reviews'); if(rv) rv.scrollIntoView({behavior:'smooth'}); }, 200);
    });
  }

  // Load saved reviews
  (function loadSaved(){
    try{
      var saved = JSON.parse(localStorage.getItem('elegance_reviews')||'[]');
      if(saved && saved.length){
        saved.reverse().forEach(function(r){
          var card = document.createElement('div');
          card.className = 'review-card';
          card.innerHTML = '<p>“'+ escapeHtml(r.text) +'”</p><strong>— '+ escapeHtml(r.name) +'</strong>';
          var grid = document.getElementById('reviews-grid');
          if(grid) grid.prepend(card);
        });
      }
    }catch(e){}
  })();

  // small animation for hero text on load
  var heroText = document.querySelector('.hero-text');
  if(heroText){ heroText.style.opacity = '0'; setTimeout(function(){ heroText.style.opacity = '1'; heroText.style.transform='translateY(0)'; }, 180); }
});
